// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".labels-list[data-v-1e3d4baa]{flex-direction:column;height:100%;width:100%;padding:5px 0 5px 45px!important}.label-item[data-v-1e3d4baa],.labels-list[data-v-1e3d4baa]{display:flex;justify-content:space-between}.label-item[data-v-1e3d4baa]{position:relative;align-items:center;font-size:14px;min-width:125px}.marker[data-v-1e3d4baa]{position:absolute;left:-20px}", ""]);
// Exports
module.exports = exports;
